import { LevelDropdownOption } from '../types'
import { ReportConfigurationType } from '../enums/report-configuration-type'
import { ReportConfigurationLevel } from '../enums/report-configuration-level'
import { PlatformLevel } from '../enums/platform-level'
import { ensureDomain, ensureOrg } from '../helpers/conditions'

export const DEFAULT_LEVEL = {
    value: ReportConfigurationLevel.DOMAIN,
    label: 'Domain',
}

const ORGANIZATION_LEVEL = {
    value: ReportConfigurationLevel.ORGANIZATION,
    label: 'Organization',
    condition: ensureOrg,
}

const TEST_LEVEL = { value: ReportConfigurationLevel.TEST, label: 'A/B Test', condition: ensureDomain }

export const LEVEL_DROPDOWN_OPTIONS: Record<ReportConfigurationType, LevelDropdownOption[]> = {
    [ReportConfigurationType.DELIVERY]: [
        ORGANIZATION_LEVEL,
        DEFAULT_LEVEL,
        { value: ReportConfigurationLevel.NOTIFICATION, label: 'Notification' },
        TEST_LEVEL,
        { value: ReportConfigurationLevel.CAMPAIGN, label: 'Campaign', condition: ensureDomain },
        { value: ReportConfigurationLevel.SEGMENT, label: 'Segment', condition: ensureDomain },
        { value: ReportConfigurationLevel.KEYWORD, label: 'Keyword', condition: ensureDomain },
    ],
    [ReportConfigurationType.SUBSCRIBER]: [
        DEFAULT_LEVEL,
        ORGANIZATION_LEVEL,
        { value: ReportConfigurationLevel.PROMPT, label: 'Prompt', condition: ensureDomain },
        TEST_LEVEL,
    ],
    [ReportConfigurationType.PUB_NETWORK]: [DEFAULT_LEVEL],
    [ReportConfigurationType.MONTHLY_UNIQUES]: [DEFAULT_LEVEL],
    [ReportConfigurationType.APP_MESSAGE]: [
        DEFAULT_LEVEL,
        { value: ReportConfigurationLevel.APP_MESSAGE, label: 'App Message' },
    ],
    [ReportConfigurationType.LIVE_ACTIVITY]: [
        DEFAULT_LEVEL,
        { value: ReportConfigurationLevel.ACTIVITY, label: 'Activity' },
    ],
    [ReportConfigurationType.NONE]: [],
}
